<template>
    <section class="home-container">
        <MasterPage title="检查报告">
            <div slot="title-icon">
                <Icon type="ios-albums" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="80">
                    <Row>
                        <Col span="8">
                        <FormItem label="报告名称：">
                            <Input v-model="selectParams.name" placeholder="请输入" />
                        </FormItem>
                        </Col>
                        <Col span="8">
                        <FormItem label="报告状态：">
                            <Select v-model="selectParams.isDeleted" @on-change="pageNum = 1" placeholder="请选择">
                                <Option value="false">未删除</Option>
                                <Option value="true" >已删除</Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="search">
                <Button type="primary" icon="md-add" @click="addModel=true">添加</Button>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindItem">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="addModel" title="新增检查报告" @on-cancel="cancelItem">
            <div style="margin-bottom: 30px">
                <Upload
                        ref="uploadImage"
                        multiple
                        type="drag"
                        :before-upload="fileBefore"
                        :on-success="fileSuccess"
                        :on-error="fileError"
                        action="food/file/upload">
                    <div :style="{padding:'30px 0'}">
                        <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                        <p>单击或拖动文件以上传</p>
                    </div>
                </Upload>
            </div>
            <Form :label-width="100">
                <FormItem label="报告名称：">
                    <Input v-model="itemAdd.name" placeholder="请输入" />
                </FormItem>
                <FormItem label="报告时间：">
                    <DatePicker v-model="itemAdd.reportTime" type="datetime" style="width: 100%" placeholder="请输入"></DatePicker>
                </FormItem>
                <FormItem label="备注：">
                    <Input v-model="itemAdd.remark" placeholder="请输入" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="addLoading" @click="addItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="updateModel" title="修改检查报告" @on-cancel="cancelItem">
            <div style="margin-bottom: 30px">
                <Upload
                        ref="uploadImageUpdate"
                        multiple
                        type="drag"
                        :before-upload="fileBefore"
                        :on-success="fileSuccess_update"
                        :on-error="fileError"
                        action="food/file/upload">
                    <div :style="{padding:'30px 0'}">
                        <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                        <p>单击或拖动文件以上传</p>
                    </div>
                </Upload>
            </div>
            <Form :label-width="100">
                <FormItem label="报告名称：">
                    <Input v-model="updateInfoItem.name" placeholder="请输入" />
                </FormItem>
                <FormItem label="上传时间：">
                    {{updateInfoItem.createTime | dateTimeToString}}
                </FormItem>
                <FormItem label="报告时间：">
                    <DatePicker v-model="updateInfoItem.reportTime" type="datetime" style="width: 100%" placeholder="请输入"></DatePicker>
                </FormItem>
                <FormItem label="备注：">
                    <Input v-model="updateInfoItem.remark" placeholder="请输入" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="updateLoading" @click="updateItem">确定</Button>
            </div>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    import {baseURL} from '../../json/common'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '用户患者',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            return h('span', this.currentPatient.name)
                        }
                    },
                    {
                        title: '报告名称',
                        key: 'name',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                    },
                    {
                        title: '文件类型',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            return h('span', params.row.url.substring(params.row.url.lastIndexOf(".")+1,params.row.url.length))
                        }
                    },
                    {
                        title: '上传时间',
                        align: 'center',
                        minWidth:100,
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            let value= params.row.createTime
                            if (value==undefined || value.length <=0)return h('span', '-')
                            let time = new Date(value)
                            let y = time.getFullYear();
                            let m = (time.getMonth()+1) < 10 ? '0' + (time.getMonth()+1):(time.getMonth()+1);
                            let d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
                            let hs = time.getHours()< 10 ? '0' + time.getHours() : time.getHours()
                            let mm = time.getMinutes()< 10 ? '0' + time.getMinutes() : time.getMinutes()
                            let s = time.getSeconds()< 10 ? '0' + time.getSeconds() : time.getSeconds()
                            return h('span', y+'-'+m+'-'+d+' '+hs+':'+mm+':'+s)
                        }
                    },
                    {
                        title: '备注',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            return h('span', params.row.remark)
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth:200,
                        render: (h, params) => {
                            let Buttons = [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'md-cloud-download',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.uploadItem(this.dataList[params.index])
                                        }
                                    }
                                }, '查看')
                            ]
                            if (this.dataList[params.index].isDeleted){
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-unlock',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.reuseItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '恢复')
                                )
                            }else{
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-create',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.updateItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '编辑')
                                )
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            icon:'md-trash',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '删除')
                                )
                            }
                            return h("div",Buttons)
                        }
                    }
                ],
                dataList: [],
                userAllList:[],
                tableLoading:false,
                addModel:false,
                addLoading:false,
                updateModel:false,
                updateLoading:false,
                infoModel:false,
                selectParams:{
                    name:'',
                    userId: '',
                    isDeleted:'false',
                },
                itemAdd:{
                    name:'',
                    userId:'',
                    url:'',
                    reportTime:'',
                    remark:'',
                },
                fileName:'',
                updateInfoItem:{reportTime:''},
                currentPatient: null,
                infoItem:'',
                pageNum:1,
                pageSize:20,
                pageTotal:0,
                baseURL:baseURL,
            }
        },
        created(){
            this.selectParams.userId = this.$route.params.patient.id
            this.currentPatient = this.$route.params.patient
            this.itemAdd.userId = this.$route.params.patient.id
            this.pageFindItem()
        },
        methods:{
            fileBefore(file){
                this.$refs.uploadImage.clearFiles()
                this.$refs.uploadImageUpdate.clearFiles()
                if (file.size > 1024*1024*40) {
                    this.$Message.warning('文件大小请勿超过40M');
                    return false
                }
                this.fileName = file.name.substr(0,file.name.lastIndexOf('.'))
                return true
            },
            fileSuccess(response){
                this.$Notice.success({title:'文件上传成功'});
                this.itemAdd.url = response.data.replace(/\\/g,"/")
                this.itemAdd.name = this.fileName
            },
            fileSuccess_update(response){
                this.$Notice.success({title:'文件上传成功'});
                this.updateInfoItem.url = response.data.replace(/\\/g,"/")
                this.updateInfoItem.name = this.fileName
            },
            fileError(error){
                this.$Notice.error({title:'文件上传失败',desc: error.message});
            },
            pageChange(value){
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            pageFindItem(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('medicalReport/list',{
                    name: this.selectParams.name,
                    userId:this.selectParams.userId == null ? "" : this.selectParams.userId,
                    isDeleted:this.selectParams.isDeleted,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'检查报告列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            addItem(){
                this.itemAdd.userId = this.currentPatient.id
                if (this.itemAdd.url.length <= 0){
                    return this.$Message.warning('请上传检查报告');
                }
                if (this.itemAdd.name.length <= 0){
                    return this.$Message.warning('请输入检查报告名称');
                }
                if (this.itemAdd.reportTime == null || this.itemAdd.reportTime.length <= 0){
                    return this.$Message.warning('请设置检查报告时间');
                }
                if (this.itemAdd.userId.length <= 0){
                    return this.$Message.warning('数据异常，请退出重试');
                }
                this.addLoading = true
                this.$http.post('medicalReport/add',{
                    name:this.itemAdd.name,
                    userId:this.itemAdd.userId == undefined ? "" : this.itemAdd.userId,
                    url:this.itemAdd.url,
                    reportTime:this.itemAdd.reportTime + '',
                    remark:this.itemAdd.remark,
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '检查报告新增成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'检查报告新增失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            updateItem_modal(item){
                this.updateInfoItem = JSON.parse(JSON.stringify(item));
                this.updateModel = true
            },
            updateItem(){
                if (this.updateInfoItem.id.length <= 0){
                    return this.$Message.warning('数据异常');
                }
                if (this.updateInfoItem.url.length <= 0){
                    return this.$Message.warning('请上传文件');
                }
                if (this.updateInfoItem.name.length <= 0){
                    return this.$Message.warning('请输入检查报告名称');
                }
                if (this.itemAdd.reportTime == null || this.itemAdd.reportTime.length <= 0){
                    return this.$Message.warning('请设置检查报告时间');
                }
                if (this.updateInfoItem.userId.length <= 0){
                    return this.$Message.warning('请选择用户患者');
                }
                this.updateLoading = true
                this.$http.post('medicalReport/update',{
                    id:this.updateInfoItem.id,
                    name:this.updateInfoItem.name,
                    userId:this.updateInfoItem.userId,
                    url:this.updateInfoItem.url,
                    reportTime:this.updateInfoItem.reportTime + '',
                    remark:this.updateInfoItem.remark,
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '检查报告修改成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'检查报告修改失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            cancelItem(){
                this.addModel = this.addLoading = this.updateModel = this.updateLoading = this.infoModel = false
                this.itemAdd = {
                    name:'',
                    userId:'',
                    url:'',
                    reportTime:'',
                    remark:'',
                }
                this.$refs.uploadImage.clearFiles()
                this.$refs.uploadImageUpdate.clearFiles()
            },
            infoItem_modal(item){
                this.infoItem = item
                this.infoModel = true
            },
            reuseItem_modal(item){
                this.$Modal.confirm({
                    title: '确认恢复检查报告“'+ item.name + '”',
                    loading:true,
                    onOk: () => {
                        this.reuseItem(item);
                    }
                });
            },
            reuseItem(item){
                this.$http.post('medicalReport/reuse',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '检查报告恢复成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'检查报告恢复失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            deleteItem_modal(item){
                this.$Modal.confirm({
                    title: '确认删除检查报告“'+ item.name + '”',
                    loading:true,
                    onOk: () => {
                        this.deleteItem(item);
                    }
                });
            },
            deleteItem(item){
                this.$http.post('medicalReport/delete',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '检查报告删除成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'检查报告删除失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            uploadItem(item){
                var eleLink = document.createElement('a')
                eleLink.href = this.baseURL + item.url
                eleLink.download = item.name
                eleLink.target = '_blank'
                eleLink.style.display = 'none'
                document.body.appendChild(eleLink)
                eleLink.click()
                document.body.removeChild(eleLink)
            },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }
</style>


